//import swiper from 'swiper/bundle';

// // こちらはCSSファイル読み込みのimport

// BootstrapのJavaScript側の機能を読み込む
//import "bootstrap";
import { Tooltip } from 'bootstrap';

// スタイルシートを読み込む
import "./index.scss";

// 制作支援
//import "./animation.js";

import "./main.js";

//import logo from './img/logo.svg';

//ページ上のすべてのツールチップを初期化
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl)
})